import { render } from "./DuelsGameHeader.vue?vue&type=template&id=36f9a7f2&scoped=true"
import script from "./DuelsGameHeader.vue?vue&type=script&lang=js"
export * from "./DuelsGameHeader.vue?vue&type=script&lang=js"

import "./DuelsGameHeader.vue?vue&type=style&index=0&id=36f9a7f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f9a7f2"]])

export default __exports__